import { SkeletonLoader } from '@design';
import React from 'react';

import styles from './DocumentLoader.module.scss';

export const DocumentLoader = () => (
  <div className={styles.skeletonWrapper}>
    <SkeletonLoader
      areas={[
        {
          styles: {
            width: '100%',
            height: '100%',
            borderRadius: '8px',
          },
        },
      ]}
    />
  </div>
);
